// Points of Interest list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="poi"
      title="Points of Interest"
      api="admin/poi"
      url="poi"
      columnsKey="poi"
      quickKey="name"
      quickPlaceholder="Filter by name…"
      perms={["pir", "pic", "piu", "pid"]}
    />
  );
}
